import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/customer/merge/customer.merge.keepSeparate.mutation.gql"
import type {
  CustomerMergeKeepSeparateMutation,
  CustomerMergeKeepSeparateMutationVariables,
} from "@/v2-backoffice-client/customer/merge/__types__/customer.merge.keepSeparate.mutation"

type Options = MutationHookOptions<
  CustomerMergeKeepSeparateMutation,
  CustomerMergeKeepSeparateMutationVariables
>

export function useCustomerMergeKeepSeparateMutation(options?: Options) {
  return useMutation<
    CustomerMergeKeepSeparateMutation,
    CustomerMergeKeepSeparateMutationVariables
  >(mutation, options)
}
